import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { log } from '../../../services/utils';

import { useAuthState } from '../../../contexts/AuthContext';
import { Provider as ProgramsProvider } from '../../../contexts/ProgramsContext';
import { Provider as SubmissionsProvider } from '../../../contexts/SubmissionsContext';
import { useUIAction } from '../../../contexts/UIContext';

import Directory from './Directory';
import Onboarding from './Onboarding';

const Agencies = () => {
	const { path: currentPath } = useRouteMatch();
	const { state: navigationState } = useLocation();

	const { user: { permissions } } = useAuthState();
	const { setSidebarMenu } = useUIAction();

	useEffect( () => {
		if ( navigationState
			? !navigationState.noSidebar
			: true
		) {
			setSidebarMenu( 'agencies' );
		}
	}, [ navigationState, setSidebarMenu ] );

	const paths = useMemo( () => {
		const pathsArr = [];

		if ( permissions.listAgencies.isAvailable ) {
			pathsArr.push( { path: `${ currentPath }/directory`, component: Directory } );
		}

		if ( permissions.listAgencies.isAvailable ) {
			pathsArr.push( { path: `${ currentPath }/onboarding`, render: () => <ProgramsProvider><SubmissionsProvider><Onboarding /></SubmissionsProvider></ProgramsProvider> } );
		}

		return pathsArr;
	}, [ currentPath, permissions ] );

	const mapPaths = useCallback( () => paths.map( path => <Route key={ path.path } { ...path } /> ), [ paths ] );

	return (
		<Switch>
			{ log( 'agencies' ) }
			{ mapPaths() }
			<Redirect from="*" to={ paths[ 0 ].path } />
		</Switch>
	);
};

export default memo( Agencies );
